import { jsx as e } from "react/jsx-runtime";
import { c as a } from "../../vendor-Blw3V4C-.js";
import { forwardRef as l } from "react";
import { stupidInvertClasses as m } from "../../utils/index.js";
import { BaseIcon as u } from "../BaseIcon/index.js";
import '../../assets/index11.css';const p = "_moon_rhddo_1", h = "_red_rhddo_5", i = "_sienna_rhddo_9", g = "_gold_rhddo_13", f = "_cactus_rhddo_17", I = "_green_rhddo_21", x = "_teal_rhddo_25", b = "_blue_rhddo_29", v = "_purple_rhddo_33", C = "_magenta_rhddo_37", j = "_calloutIcon_rhddo_42", w = "_sm_rhddo_47", z = "_md_rhddo_51", o = {
  moon: p,
  red: h,
  sienna: i,
  gold: g,
  cactus: f,
  green: I,
  teal: x,
  blue: b,
  purple: v,
  magenta: C,
  calloutIcon: j,
  sm: w,
  md: z
}, B = {
  sm: "lg",
  md: "xl"
}, y = l(
  ({ icon: d, color: s = "moon", __inverted: t, size: n = "md", ..._ }, c) => {
    const r = a(
      o.calloutIcon,
      o[s],
      o[n],
      t ? m() : void 0
    );
    return /* @__PURE__ */ e(
      u,
      {
        ..._,
        ref: c,
        icon: d,
        size: B[n],
        color: s,
        className: r
      }
    );
  }
);
export {
  y as CalloutIcon
};
//# sourceMappingURL=index.js.map
